/** نماذج القرارات وسجل التفويضات كما يعدلها استوديو سير العمل: كل تعديل إصدار جديد تعتمده الإدارة. */
export default {
  tabTemplates: "نماذج القرارات",
  tabSignatories: "الموقعون",
  templatesHint: "صيغة كل قرار توقعه المنصة. يحفظ التعديل إصدارا جديدا لا يصدر به قرار قابل للتوقيع إلا بعد أن يعتمده خبير قانوني أو المدير غيرك من نظام إدارة الحالات (المعرفة القانونية › نماذج القرارات). ويستشهد بكل مادة بمرجعها في سجل القواعد القانونية (المبين تحت «قواعد السجل»)، ويرفض كتابة المادة نصا.",
  version: "الإصدار {{version}}",
  status: { Approved: "معتمد", AwaitingApproval: "بانتظار الاعتماد", EditedSinceApproval: "معدل بعد اعتماده" },
  pending: "الإصدار {{version}} بانتظار الاعتماد",
  editing: "التعديل انطلاقا من الإصدار {{version}}",
  arabic: "العربية",
  english: "الإنجليزية",
  note: "ما يغيره هذا الإصدار",
  save: "حفظ إصدار جديد",
  saved: "حفظ الإصدار الجديد وهو بانتظار اعتماد الإدارة",
  placeholders: "الحقول المتغيرة",
  rules: "قواعد السجل",
  choose: "لم يحدد نموذج بعد: تعدل صيغة النموذج بعد تحديده من القائمة.",
  signatoriesHint: "من يوقع كل قرار وبأي صفة وبموجب أي تفويض، مع تواريخ سريان كل منها. ويسمي التكليف بالإنابة الموظف المكلف (معرف المستخدم). يحفظ التعديل إصدارا جديدا من السجل لا توقع القرارات بموجبه إلا بعد أن يعتمده خبير قانوني أو المدير غيرك.",
  key: "المفتاح",
  capacity: "الصفة",
  capacityAr: "الصفة (بالعربية)",
  authority: "السند",
  authorityAr: "السند (بالعربية)",
  role: "دور الموقع",
  instrument: "نوع القرار",
  instruments: { Ministerial: "قرار وزاري", Administrative: "قرار إداري" },
  name: "الاسم",
  nameAr: "الاسم (بالعربية)",
  userId: "معرف مستخدم الموظف (التكليف بالإنابة)",
  acting: "بالإنابة",
  from: "ساري من",
  to: "ساري حتى",
  outcomes: "نتائج القرار (مفصولة بفواصل)",
  caseTypes: "الإجراءات (مفصولة بفواصل؛ فارغة للتركز)",
  verification: "التحقق",
  add: "إضافة تفويض",
  remove: "حذف",
  savedRegister: "حفظ إصدار جديد من السجل وهو بانتظار اعتماد الإدارة",
} as const;
